import { TextField, Autocomplete, Checkbox, Chip } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useState } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function FilterAutocomplete({
  onChange,
  options,
  label,
  value,
  onApplyClick,
  field,
  onDeleteClick,
}) {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  return (
    <Autocomplete
      disablePortal
      disableClearable
      limitTags={3}
      disableCloseOnSelect
      id="combo-box-demo"
      multiple
      getOptionLabel={(op) => op.label}
      value={value}
      open={isDropDownOpen}
      onOpen={() => setIsDropDownOpen(true)}
      onClose={() => setIsDropDownOpen(false)}
      onBlur={() => onApplyClick()}
      sx={{
        "span.MuiAutocomplete-tag": {
          background: "transparent",
          color: "#000",
          fontWeight: 600,
        },
        "& .MuiInputLabel-root": {
          lineHeight: "normal",
        },
      }}
      onChange={onChange}
      isOptionEqualToValue={(option, _value) => option.id === _value.id}
      renderOption={(props, option, { selected }) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.label}
        </li>
      )}
      options={options}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            variant="outlined"
            label={option?.label}
            {...getTagProps({ index })}
            onDelete={() => {
              const filters = value.filter((item) => item.id !== option.id);
              onDeleteClick(field, filters);
            }}
          />
        ))
      }
      renderInput={(params) => <TextField {...params} label={label} fullWidth />}
    />
  );
}

export default FilterAutocomplete;
